/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Selfhost_CtaInputs */

const en_mk_sec_pg_selfhost_cta = /** @type {(inputs: Mk_Sec_Pg_Selfhost_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk about self-hosting`)
};

const id_mk_sec_pg_selfhost_cta = /** @type {(inputs: Mk_Sec_Pg_Selfhost_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bicarakan self-host`)
};

/**
* | output |
* | --- |
* | "Talk about self-hosting" |
*
* @param {Mk_Sec_Pg_Selfhost_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_selfhost_cta = /** @type {((inputs?: Mk_Sec_Pg_Selfhost_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Selfhost_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_selfhost_cta(inputs)
	return en_mk_sec_pg_selfhost_cta(inputs)
});